"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userPhotoLayerHasMaxCrop;
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
function userPhotoLayerHasMaxCrop(userData) {
  var _a, _b, _c, _d;
  if (!userData || (0, UserPhotoLayer_1.isDefaultModifications)(userData.modifications)) {
    return true;
  }
  return ((_a = userData.modifications.crop) === null || _a === void 0 ? void 0 : _a.width) === userData.imageData.width || ((_b = userData.modifications.crop) === null || _b === void 0 ? void 0 : _b.width) === userData.imageData.height || ((_c = userData.modifications.crop) === null || _c === void 0 ? void 0 : _c.height) === userData.imageData.width || ((_d = userData.modifications.crop) === null || _d === void 0 ? void 0 : _d.height) === userData.imageData.height;
}